import { ButtonUI } from '@/components';
import { ICartInfoItem, IOrderInfo } from '@/models';
import { InformationCircleIcon } from '@heroicons/react/24/outline';
import { useRouter } from 'next/router';
import React, { useEffect } from 'react';
// import Lottie from 'react-lottie-player';
import SUCCESS from './animate_success.json';
import CartItemOrder from './CartItemOrder';
import { useAppSelector } from '@/hooks';
import { cartSelectors } from '@/store/reducers/cartSlice';

interface IOrderPage {
	status: IOrderInfo;
	dataCode?: string;
	formatConfig?: ICartInfoItem[];
}

const OrderPage: React.FC<IOrderPage> = ({ status, dataCode, formatConfig }) => {
	const cartInfo = status?.data?.order_info;
	const router = useRouter();

	const cartSelector = useAppSelector(cartSelectors);

	useEffect(() => {
		window.scrollTo({ behavior: 'smooth', top: 0 });
	}, []);

	return (
		<div className='px-2.5 lg:container py-4 lg:py-24 h-full lg:max-w-[650px] w-full'>
			<div className='bg-base-100 text-center h-fit p-2.5 lg:p-[54px]'>
				{/* <Lottie
					// loop={false}
					animationData={SUCCESS}
					play
					className='w-full lg:w-[350px]'
					style={{ height: '150px', margin: '0 auto', fill: '#23A79C' }}
				/> */}
				<div className='text-medium lg:text-large font-bold text-primary py-[20px] lg:py-[40px]'>
					Đơn hàng{' '}
					<span className='text-[#23A79C] hover:underline cursor-pointer'>#{dataCode}</span> đang
					được xử lý
				</div>
				<div className='text-base lg:text-medium pb-7 lg:pb-14'>
					Đơn hàng của quý khách đã được chuyển đến bộ phận xử lý. Quý khách có thể tiếp tục mua sắm
					và sẽ có nhân viên hỗ trợ ..
				</div>
				<div className='text-large lg:text-large-3x font-bold text-primary pb-11'>
					Nga Liêm Shop Xin chân thành cảm ơn quý khách
				</div>
				<ButtonUI
					color='primary'
					text='Tiếp tục mua sắm'
					onClick={() => router.push('/')}
					className='flex justify-center mx-auto w-[70%]'
				/>
				<div className='text-base lg:text-medium flex justify-start pt-[20px] lg:pt-[40px] pb-4 lg:pb-8 font-bold'>
					Đơn hàng #{status?.data?.id}
				</div>
				{formatConfig?.length ? (
					<>
						<div className='max-h-[425px] overflow-y-auto'>
							{formatConfig?.map((k, i) => (
								<CartItemOrder data={k} key={i} />
							))}
						</div>
						<div className='flex items-center text-primary justify-between pt-[20px] lg:pt-[40px]'>
							<span className='text-base lg:text-medium font-bold'>Tổng chi phí</span>
							<span className='text-large lg:text-large-2x font-bold'>
								{Number(cartSelector.dataCart.totalPrice)?.toLocaleString('it-IT')}₫
							</span>
						</div>
						<div className='flex text-primary item gap-[22px] mt-[20px] lg:mt-[40px]'>
							<InformationCircleIcon width={70} />
							<span className='text-small'>
								Giá tiền chưa bao gồm phí vận chuyển. Sau khi Nga Liêm nhận đơn hàng sẽ có nhân viên
								hỗ trợ, tư vấn cho mình về chi phí vận chuyển.
							</span>
						</div>
					</>
				) : null}
			</div>
		</div>
	);
};

export default OrderPage;
